import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex overflow-x-auto" }
const _hoisted_2 = { class: "w-full mt-6 table-fixed" }
const _hoisted_3 = { class: "font-bold text-left border-b-2 border-black" }
const _hoisted_4 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_5 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_6 = { class: "px-2 py-6 capitalize md:py-3 whitespace-nowrap" }
const _hoisted_7 = { class: "px-2 py-2 space-x-3 whitespace-nowrap" }

import { PropType } from "vue";
import { storeToRefs } from "pinia";

import { useUserStore } from "@/store";
import { Student } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'ParentChildTable',
  props: {
  students: {
    type: Array as PropType<Student[]>,
    required: true,
  },
},
  setup(__props) {

const { user } = storeToRefs(useUserStore());



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", _hoisted_3, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t("name")), 1),
          _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t("actions")), 1)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.students, (student) => {
          return (_openBlock(), _createElementBlock("tr", {
            class: "border-b border-gray-400",
            key: student.id
          }, [
            _createElementVNode("td", _hoisted_6, _toDisplayString(student.first_name) + _toDisplayString(student.middle_name? ` ${student.middle_name}`: '') + " " + _toDisplayString(student.last_name), 1),
            _createElementVNode("td", _hoisted_7, [
              (_unref(user).id === student.primary_parent)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: `/dashboard/children/${student.id}/edit`,
                    class: "underline text-blue"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("manage-profile")), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : _createCommentVNode("", true),
              (student.clubs.length)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: `/dashboard/clubs/${student.clubs[0].id}?tab=attendance`,
                    class: "underline text-blue"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("view-sessions")), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})